@if(errors.length > 0) {
    <div class="invalid-feedback d-block">
        <ul>
            @for(e of errors; track e) {
                <li>{{e}}</li>
            }
        </ul>
    </div>
}